// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1uPUp","video":"styles_video__uyVft","videoHolder":"styles_videoHolder__3oPXy"};